import { render, staticRenderFns } from "./ArrowIcon.vue?vue&type=template&id=9c9a5c5a&"
import script from "./ArrowIcon.vue?vue&type=script&lang=ts&"
export * from "./ArrowIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9c9a5c5a', component.options)
    } else {
      api.reload('9c9a5c5a', component.options)
    }
    module.hot.accept("./ArrowIcon.vue?vue&type=template&id=9c9a5c5a&", function () {
      api.rerender('9c9a5c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/ArrowIcon.vue"
export default component.exports